import { useTheme } from '@mui/material/styles';
const useIsExternalTheme = ()=>{
    const theme = useTheme();
    return theme.type === 'external';
};
export default useIsExternalTheme;
